export const RemovalReasonTypeDetailExcelHeader = [
  {
    header: "REMOVAL REASON TYPE DETAIL CODE",
    key: "REMOVAL REASON TYPE DETAIL CODE",
  },
  {
    header: "REMOVAL REASON TYPE DETAIL NAME",
    key: "REMOVAL REASON TYPE DETAIL NAME",
  },
  {
    header: "IS REQUIRED",
    key: "IS REQUIRED",
  },
  {
    header: "CREATED BY",
    key: "CREATED BY",
  },
  {
    header: "CREATED DATE",
    key: "CREATED DATE",
  },
];

export const RemovalReasonTypeDetailExcelName = "Removal Reason Type Detail List";
